import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import {
	AddDeviceRequestStatus,
	AddDeviceStatusEvent,
} from '../add-device-main-tab.component';
import { Router } from '@angular/router';
import { SerialNumber } from 'src/app/models/data/device';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { TransferDeviceOwnershipError } from 'src/app/models/data/deviceTransfer';
import {
	MatTableDataSource,
	MatTable,
	MatNoDataRow,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatOption } from '@angular/material/select';
import {
	DataSetComponent,
	DataSetContentComponent,
} from '../../../../components/data-set/data-set.component';
import { DataSetTableComponent } from '../../../../components/data-set/data-set-table.component';
import { MatSort, MatSortHeader } from '@angular/material/sort';

@Component({
	selector: 'app-add-device-confirmation',
	templateUrl: './add-device-confirmation.component.html',
	styleUrls: [
		'./add-device-confirmation.component.scss',
		'../../../../ui/common/main.scss',
	],
	imports: [
		MatDivider,
		MatProgressSpinner,
		MatOption,
		DataSetComponent,
		DataSetContentComponent,
		DataSetTableComponent,
		MatTable,
		MatSort,
		MatNoDataRow,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatSortHeader,
		MatCellDef,
		MatCell,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
	],
})
export class AddDeviceConfirmationComponent implements OnInit {
	@Output() goBack = new EventEmitter<boolean>();

	@Input() deviceCount = 0;
	@Input() addDeviceRequestStatusEvents!: Observable<AddDeviceStatusEvent>;

	showLoading = false;
	showSuccess = false;
	showFailure = false;
	serialNumberErrorList!: SerialNumber[];

	isTransferringDevices: boolean = false;
	transferToCompanyName?: string;

	displayedColumns: string[] = ['deviceSerialNumber', 'deviceType', 'error'];
	dataSource = new MatTableDataSource<TransferDeviceOwnershipError>();

	errorNotOwnedBySL = $localize`:@@addDeviceConfirmation-errorNotOwnedBySLDescWithTrademark:Device not associated with SentriKey® Access`;
	errorNotAssociatedWithAccess = $localize`:@@addDeviceConfirmation-errorNotAssociatedWithAccessDesc:Device not found in database`;

	constructor(
		private readonly router: Router,
		private readonly navHistory: NavigationHistoryService
	) {}

	ngOnInit(): void {
		this.addDeviceRequestStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			if (event.data?.serialNumberErrorList) {
				this.serialNumberErrorList = event.data?.serialNumberErrorList;
			}

			if (event.data?.errorsFromTransferredDevices) {
				this.dataSource.data = event.data?.errorsFromTransferredDevices;
			}

			if (event.isTransferringDevices) {
				this.isTransferringDevices = event.isTransferringDevices;
			}

			if (event.transferToCompanyName) {
				this.transferToCompanyName = event.transferToCompanyName;
			}

			switch (event.status) {
				case AddDeviceRequestStatus.loading:
					this.showLoading = true;
					break;
				case AddDeviceRequestStatus.success:
					this.showSuccess = true;
					break;
				case AddDeviceRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	onGotoDevicesClicked(): void {
		this.router.navigateByUrl(`/devices?tabIndex=0`);
	}

	onCheckErrorsClicked(): void {
		this.goBack.emit(true);
	}

	onMoveAdditionalDevicesClicked(): void {
		this.goBack.emit(true);
	}
}
